import styled from "styled-components"

const ActuTaxo = styled.p`
  margin: 0;
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const ActualiteTitle = styled.h2`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & ~ div:last-of-type {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

export { ActuTaxo, ActualiteTitle }
